module.exports = __webpack_public_path__ + "img/Logo-Verde.4bf31446.png";